import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import CurrentClass from '@/pages/userspace/currentclass'
import PubContinue from '@/pages/hourweb/pubcontinue'

import LearnAddEdit from '@/pages/learntask/addedit'
import LearnTaskList from '@/pages/learntask/list'

import Userlist from '@/pages/learntask/userlist'

import Statistics from '@/pages/statistics'

import Notice from '@/pages/notice'
import NoticeEdit from '@/pages/notice/edit'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/CurrentClass',
      name: 'CurrentClass',
      component: CurrentClass
    },
    {
      path: '/PubContinue',
      name: 'PubContinue',
      component: PubContinue
    },
    {
      path: '/LearnAddEdit',
      name: 'LearnAddEdit',
      component: LearnAddEdit
    },
    {
      path: '/LearnTaskList',
      name: 'LearnTaskList',
      component: LearnTaskList
    },
    {
      path: '/Userlist',
      name: 'Userlist',
      component: Userlist
    },
    {
      path: '/Statistics',
      name: 'Statistics',
      component: Statistics
    },
    {
      path: '/Notice',
      name: 'Notice',
      component: Notice
    },
    {
      path: '/NoticeEdit',
      name: 'NoticeEdit',
      component: NoticeEdit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js